import { Dispatch } from 'redux';

import {
  InternshipFunctions,
  fetchInternshipFunctions as apiFetchInternshipFunctions,
} from 'api/orgs';

import { setError } from './error';

// Types

export type MainStoreInternshipFunctionsState =
  | InternshipFunctions
  | null
  | undefined;

export type MainStoreInternshipFunctionsAction = {
  type: 'INTERNSHIP_FUNCTIONS_SET';
  internshipFunctions: InternshipFunctions | null | undefined;
};

// Reducer

export function internshipFunctionsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreInternshipFunctionsState = null,
  action: MainStoreInternshipFunctionsAction
) {
  switch (action.type) {
    case 'INTERNSHIP_FUNCTIONS_SET': {
      return action.internshipFunctions;
    }

    default:
      return state;
  }
}

// Actions

export const fetchInternshipFunctions =
  () =>
  (
    dispatch: Dispatch<MainStoreInternshipFunctionsAction>,
    getState: () => { internshipFunctions: MainStoreInternshipFunctionsState }
  ) => {
    if (getState().internshipFunctions) {
      return;
    }

    apiFetchInternshipFunctions()
      .then((internshipFunctions) => {
        dispatch({
          type: 'INTERNSHIP_FUNCTIONS_SET',
          internshipFunctions,
        });
      })
      .catch(setError);
  };
